<template>
    <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g clip-path="url(#clip0)">
            <path d="M4 0.992188V9.00781M4 0.992188L1 3.99219M4 0.992188L7 3.99219" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="8" height="10" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconHigher',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
